import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

export function useAuthListener() {
  const navigate = useNavigate();

  useEffect(() => {
    function handleUnauthorized() {
      toast.error('登录已过期，请重新登录');
      navigate('/login', { replace: true });
    }

    window.addEventListener('auth:unauthorized', handleUnauthorized);
    return () => window.removeEventListener('auth:unauthorized', handleUnauthorized);
  }, [navigate]);
}
